export default __webpack_public_path__ + "static/media/logo.d7336ac2.png";